import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from "@material-ui/core";
import { UserContext } from "../context/UserContext";

interface IProps {
  open: boolean;
  onClose: () => void;
}
export default function InactivityDialog(props: IProps) {
  const { open, onClose } = props;
  const [isOpen, setIsOpen] = React.useState(open);
  const user = React.useContext(UserContext);

  React.useEffect(() => {
    let timer: any = null;
    if (open) {
      timer = setTimeout(() => {
        user.logout();
        setIsOpen(false);
      }, 1000 * 60 * 5);
    } else {
      if (timer) clearTimeout(timer);
    }
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [open, user]);

  return (
    <Dialog open={isOpen}>
      <DialogTitle>Session Timeout</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          Due to inactivity, you will be logged out soon.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          form="create-employee-form"
          color="primary"
          type="submit"
          onClick={onClose}
        >
          Keep Me Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
}
